<template>
    <b-tab title-link-class="p-0">
        <template v-slot:title>
            <b-nav-item-dropdown>
                <template slot="button-content">
                    <i class="famfamfam-silk cus-vcard"></i>
                    Contact Details
                </template>
                <b-dropdown-item href="#" @click="loadList">
                    <i class="cus-vcard"></i>View Contact Details
                </b-dropdown-item>
                <div class="dropdown-divider"></div>
                <b-dropdown-item @click.stop="addContactDetail">
                    <i class="cus-add"></i> New Contact Detail
                </b-dropdown-item>
            </b-nav-item-dropdown>
        </template>
        <b-card-text>
            <contact-detail-list
                ref="contactDetailList"
                :key="componentKey"
                v-on="$listeners"
            />
        </b-card-text>
    </b-tab>
</template>
<script>
export default {
    components: {
        ContactDetailList: () =>
            import("@/components/client-contact-details/contact-detail-list")
    },
    data() {
        return {
            componentKey: 0
        };
    },
    watch: {
        componentKey(value) {
            this.$nextTick(() => {
                let isListRendered = this.$refs.contactDetailList;

                // reset filter if list is not rendered
                if (!isListRendered) {
                    this.$store.commit("client/resetContactDetailsFilter");
                }
            });
        }
    },
    mounted() {},
    methods: {
        loadList() {
            this.componentKey += 1;
        },
        addContactDetail() {
            this.$emit("open-contact-modal");
        }
    }
};
</script>
